module.exports = __webpack_public_path__ + "static/media/michelle.522cc576.jpg";